import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/p/catalogo/$slug/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            params: { slug: params.slug },
            replace: true,
            search: (s) => s,
            to: '/p/catalogo/$slug/produtos',
        });
    },
});
